import React from 'react'
function PaymentStepsOne() {
  return (
    <div id="stepper">
      <ul class="steps">
        <li class="complete">
          <span>Payment Mode</span>
        </li>
        <li class="non-active">
          <span>Payment Complete</span>
        </li>
    </ul>
  </div>
  )
}
export default PaymentStepsOne
